import { render, staticRenderFns } from "./AppModalBottomPopup.vue?vue&type=template&id=3a240df3&scoped=true"
import script from "./AppModalBottomPopup.vue?vue&type=script&lang=js"
export * from "./AppModalBottomPopup.vue?vue&type=script&lang=js"
import style0 from "./AppModalBottomPopup.vue?vue&type=style&index=0&id=3a240df3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a240df3",
  null
  
)

export default component.exports